import * as toastr from 'toastr';
import * as _ from 'lodash';

import { Log } from './Log';
import { ILogger } from './ILogger';
import { Logger } from './Logger';

export class LoggerFactory {
    private static _loggers: any = {};
    private static _forceLevel: number;

    static getLogger(name: string, toast?: boolean, level?: number): ILogger {
        let logger: ILogger;
        if (LoggerFactory._loggers.hasOwnProperty(name)) {
            logger = LoggerFactory._loggers[name];

        } else {
            logger = new Logger(console, toastr, name);
            LoggerFactory._loggers[name] = logger;
        }
        logger.toast(toast);
        if (!LoggerFactory.forceLevel()) {
            logger.level(level);
        } else {
            logger.level(LoggerFactory.forceLevel());

        }
        return logger;
    }

    static forceLevel(value?: number): number {
        if (value) {
            LoggerFactory._forceLevel = value;
            for (const key of Object.keys(LoggerFactory._loggers)) {
                LoggerFactory._loggers[key].level(value);
            }
        }
        return LoggerFactory._forceLevel;
    }

    static getAllLogs(): Log[] {
        let logs: Log[] = [];
        for (const key of Object.keys(LoggerFactory._loggers)) {
            logs = logs.concat(LoggerFactory._loggers[key].getLogs());
        }
        return logs;
    }
}